module.exports = __webpack_public_path__ + "static/img/devLopBtn.4a9bd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/devLopBtn.png
// module id = uvM2
// module chunks = 0